<div class="file-upload-container"
     (click)="fileInput.click()"
     fileDragDrop
     (fileDropped)="dropFile($event)">
  <input hidden
         type="file"
         #fileInput
         [accept]="acceptTypes"
         (change)="selectFile($event)">
  <mat-icon color="accent" class="upload-icon">cloud_upload</mat-icon>
  <div *ngIf="fileTypes" class="file-types-note text-disabled-color">
    <ng-container i18n="File Upload|allowed file types label@@file-upload-allowed-file-types-label">
      Allowed file types:
    </ng-container>
    {{fileTypes}}
  </div>
</div>

<div class="file-upload-selected-file" *ngFor="let file of files; let i= index">
  <p class="selected-file"> {{ file?.name }} </p>

  <app-button icon="delete"
              [secondary]="true"
              [destructive]="true"
              class="delete-file"
              (clicked)="deleteAttachment(i)"></app-button>
</div>

<div *ngIf="!files.length" class="file-upload-selected-file text-disabled-color">
  <div class="center-middle" i18n="File Upload|No file selected label@@file-upload-no-file-selected-label">No files
    selected</div>
</div>
